<template>
  <div
    class="border border-solid border-gray-200 cursor-move py-2 px-4 bg-white rounded"
  >
    <div
      v-if="!is_editing_question"
      class="flex justify-between items-center space-x-2"
    >
      <div class="flex items-center space-x-3.5">
        <button class="h-5 cursor-move">
          <i class="fa-solid fa-grip-vertical text-blueGray-600"></i>
        </button>
        <a
          class="text-gray-700 hover:underline cursor-pointer border border-solid border-white"
        >
          {{ question.question }}
        </a>
      </div>
      <div class="flex space-x-3 items-center">
        <div>
          <button
            @click="handleEditQuestion"
            title="Edit Question"
            class="py-1 border border-solid border-gray-300 px-3 bg-gray-100 text-blueGray-700 text-xs rounded"
          >
            Edit
          </button>
        </div>
        <button
          @click="handleDeleteQuestion(question)"
          title="Remove"
          class="text-red-500"
        >
          <i class="fa-solid fa-square-minus"></i>
        </button>
      </div>
    </div>
    <div v-else>
      <div class="flex items-center justify-between w-full">
        <div class="flex items-center space-x-3.5 w-full">
          <button class="h-5 cursor-move">
            <i class="fa-solid fa-grip-vertical text-blueGray-600"></i>
          </button>
          <input
            @keyup.enter="handleSaveInformation(question)"
            ref="question"
            v-model="question.question"
            class="border-white w-full truncate focus-within:border-white"
          />
        </div>
        <div class="flex items-center space-x-3">
          <button
            @click="handleSaveInformation(question)"
            title="Save"
            class="py-1 px-3 border border-solid border-green-500 text-green-600 bg-green-100 text-xs rounded"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        is_editing_question: false,
      };
    },
    props: {
      question: {
        type: Object,
        default() {
          return {};
        },
      },
    },
    methods: {
      handleEditQuestion() {
        this.is_editing_question = true;
      },
      handleDeleteQuestion(q) {
        this.$emit('handleDeleteQuestion', q);
      },
      handleSaveInformation(q) {
        this.$emit('handleSaveInformation', q);
        this.is_editing_question = false;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// followUpQuestion.vue?4b5c486e